var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2334_27329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.66095 16 0 12.3336 0 7.99593C0 3.6802 3.63811 0 7.99186 0C12.3195 0 16 3.66167 16 7.99593C16 12.3277 12.3342 16 8 16Z",
    fill: "#5756CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01619 12.0671C8.43791 12.0671 8.77305 11.7532 8.77305 11.3262V7.64576L8.69981 6.00912L9.39971 6.90479L10.2624 7.80861C10.5148 8.09272 10.9983 8.10319 11.2715 7.84118C11.5549 7.56898 11.5282 7.11477 11.2634 6.83965L8.62656 4.15263C8.4421 3.95721 8.23864 3.8595 8.01619 3.8595C7.78831 3.8595 7.58214 3.95721 7.39767 4.15263L4.76085 6.83965C4.50038 7.11068 4.48241 7.57074 4.75271 7.84118C5.02559 8.10282 5.50929 8.09289 5.76186 7.80861L6.64081 6.8885L7.32443 6.00912L7.24304 7.64576V11.3262C7.24304 11.7631 7.58918 12.0671 8.01619 12.0671Z",
    fill: "#FCFCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2334_27329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.57935a8245864082ba4657509d509403.svg";
export { ForwardRef as ReactComponent };